export const INFO_POSITION_VALUES = {
  ON_VIDEOS: 1,
  BELOW_VIDEOS: 2,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/info-position-values.js